<template>
  <div class="line-button">
    <div class="divider" />

    <BbTooltip
      :key="tooltipPlacement"
      v-bind="{ placement: tooltipPlacement, offset: 4, isDisabled: disabled, content: tooltip }"
    >
      <InsertLayoutButton @click="$emit('click-btn', $event)" />
    </BbTooltip>

    <div class="divider" />
  </div>
</template>

<script>
import InsertLayoutButton from '~/components/common/InsertLayoutButton.vue';

export default {
  components: { InsertLayoutButton },
  props: {
    tooltip: { type: String, default: '' },
    tooltipPlacement: { type: String, default: 'top' },
    disabled: { type: Boolean, default: false },
  },
  emits: ['click-btn'],
};
</script>

<style lang="scss" scoped>
.line-button {
  display: flex;
  align-items: center;
  justify-content: center;

  .divider {
    height: 2px;
    background-color: $bb-primary-3;
    width: 35%;
  }
}
</style>
